<template>
  <div class="page">
    <h1>测试导航</h1>
    <div>
      <h2>登录/授权</h2>
      <div class="lables">
        <button @click="auth">登录</button>
        <button v-if="isWechat" @click="unbind">取消绑定</button>
      </div>
    </div>
    <div>
      <h2>页面</h2>
      <div class="lables">
        <router-link to="mine">个人中心</router-link>
        <router-link to="orders">订单中心</router-link>
        <router-link to="preview">组件预览</router-link>
        <router-link to="feedback">意见反馈</router-link>
        <router-link to="page">页面</router-link>
      </div>
    </div>
    <div>
      <h2>上传图片</h2>
       <van-uploader
        class="uploader"
        v-model="filtList"
        :max-count="1"
        :before-read="beforeRead"
      />
      <button @click="uploadImage">上传</button>
    </div>
    <div>
      <h2>全局导航</h2>
      <div class="lables">
       <button @click="changeNav(true)">显示</button>
       <button @click="changeNav(false)">关闭</button>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { httpUser } from "../../scripts/network";
import { login, unbind } from "../../scripts/auth";
import { SHOW_NAV } from "../../store/mutation-types";
import { httpOpen } from "../../scripts/network";
import { Uploader } from "vant";
Vue.use(Uploader);

export default {
  name: "home",
  data() {
    return {
      phone: "18180948007",
      isWechat: this.$store.state.isWechat,
      filtList:[],
    };
  },
  mounted() {
    // this.$store.dispatch(SHOW_NAV, false);
  },
  methods: {
    async getGraphCode() {
      if (this.phone) {
        this.cancelValidate && this.cancelValidate();
        const params = {
          param: {
            "para.tag": this.phone,
            "para.width": 120,
            "para.height": 45
          }
        };
        let ret;
        try {
          ret = await httpUser("/User/GetImgValidCode", params, cancel => {
            this.cancelValidate = cancel;
          });
        } catch (error) {
          console.error("----", error);
        }
        if (ret && ret.Status) {
          this.image = ret.Data;
        }
      }
    },
    auth() {
      login(this.$store, this.$router);
    },
    unbind() {
      unbind();
    },
    changeNav(show) {
     this.$store.dispatch(SHOW_NAV, show);
    },
    dataBase64toBlob(dataurl) {
      var arr = dataurl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new Blob([u8arr], {
        type: mime
      });
    },
    async uploadImage() {
      try {
        if (!this.filtList || this.filtList.length === 0) {
          return;
        }
        let img = this.filtList[0].content;
        
        let formData = new FormData();
        const data = this.dataBase64toBlob(img)
        formData.append("file",data)
        const ret = await httpOpen("/Common/ImageFileUpload", {
          type: "POST",
          timeout: 90000,
          body: formData
        });
        if (ret.Status) {
          this.$toast("上传成功")
        }else{
          this.$toast(ret.Message)
        }
      } catch (e) {
        console.log(e);
      }
    },
    test() {
      console.log("====>", this.$router);
      let { path, query } = this.$router.history.current;
      this.$router.replace({
        path: "/auth",
        query: {
          redirect: JSON.stringify({
            path: path,
            query: query
          })
        }
      });
      // this.getGraphCode()
      // this.$router.push({path:'/mine'})
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.lables {
  display: flex;
  flex-flow: row wrap;
}
.lables > * {
  margin-left: 8px;
  margin-top: 8px;
}
h2 {
  margin: 16px 0px 8px 8px;
}
h2 + * {
  margin-left: 16px;
}
h3 {
  margin: 40px 0 0;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a,
button {
  background: #42b983;
  border: none;
  height: 36px;
  line-height: 36px;
  padding: 0px 16px;
  border-radius: 8px;
  color: white;
}
</style>
